import { useEffect, useRef, useState } from "react";
import { Id, toast } from "react-toastify";

import { UseApiWithToastOptionsProps } from "./useGetWithToast";
import useToast, { EToastType } from "./useToast";

export const useDeleteWithToast = ({
  isLoading = false,
  isSuccess = false,
  isError = false,
  loadingMessage = "Loading...",
  successMessage = "Loaded successfully.",
  errorMessage = "An error occurred."
}: UseApiWithToastOptionsProps) => {
  const { showToast } = useToast();
  const loadingToastId = useRef<Id | undefined>(undefined);
  const [successToastShown, setSuccessToastShown] = useState(false);

  useEffect(() => {
    if (isLoading) {
      if (!loadingToastId.current) {
        // Only show a new loading toast if one isn't already displayed
        const toastId = showToast({
          message: loadingMessage,
          type: EToastType.LOADING
        });
        loadingToastId.current = toastId; // Store the ID
      }
    } else {
      if (loadingToastId.current) {
        // Dismiss the loading toast if it exists
        toast.dismiss(loadingToastId.current);
        loadingToastId.current = undefined; // Reset the ID
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, loadingMessage]);

  useEffect(() => {
    if (!isLoading && (isSuccess || isError)) {
      if (isSuccess && successMessage && !successToastShown) {
        showToast({ message: successMessage, type: EToastType.SUCCESS });
        setSuccessToastShown(true);
      }
      if (isError && errorMessage) {
        showToast({
          message: errorMessage,
          type: EToastType.ERROR
        });
      }
    } else {
      setSuccessToastShown(false); //reset success flag when all are false.
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, isError, isLoading, successMessage, errorMessage]);
};
